import { getEnumMap, isEmpty } from "@/utils/Common";
import store from "@/stores/index";

let patentType: Map<string, any> | null = null;
let userLevel: Map<string, any> | null = null;

const map: any = {
  formatPatentType(data: any, column: any, value: any) {
    if (isEmpty(patentType)) {
      patentType = getEnumMap(store.getters["enums/getEnumsByKey"]("PatentType"));
    }
    return `<div class="cell-notice-wrapper ${value} ">${patentType ? patentType.get(value) : value}</div>`;
  },

  formatUserLevel(data: any, column: any, value: any) {
    if (isEmpty(userLevel)) {
      userLevel = getEnumMap(store.getters["enums/getEnumsByKey"]("UserLevel"));
    }
    return userLevel ? userLevel.get(value) : value;
  },
};

export function mapFormatters(names: Array<string>) {
  if (!names || !names.length) {
    return {};
  }
  const funcs: { [key: string]: Function } = {};
  names.forEach((name) => {
    funcs[name] =
      map[name] ||
      function (data: any, column: any, value: any) {
        return value;
      };
  });
  return funcs;
}

export default map;
